/* eslint-disabled */
import SmsJob from "./SmsJob";
import Action from "./Action";
import SmsTemplateExtend from "@/entity/extends/SmsTemplateExtend";
import { hydrateCollection } from "@/Utils/EntityHelper";

export default class SmsTemplate extends SmsTemplateExtend {

    public id!: number;
    public sender = '';
    public content = '';
    public jobs: Array<SmsJob> = [];
    public action: Array<Action> = [];
    public name = '';
    public description? = '';
    public defaultRecipients: any[] = [];
    public label? = '';

    constructor(object?: any) {
        super(object)
        if (object) {
            this.id = object.id;
            this.sender = object.sender;
            this.content = object.content;
            hydrateCollection(object.jobs, SmsJob, this.jobs);
            hydrateCollection(object.action, Action, this.action);
            this.name = object.name;
            this.description = object.description;
            this.defaultRecipients = object.defaultRecipients;
            this.label = object.label;
        }
        this.postConstruct()
    }

}
